/* angular:styles/component:scss;97ffcc362e04ea016ad2e5bd0ae2e407bbcb3d7e17199b6891f826ba83a6ece5;D:\Blueberry_ERP\HRMS-Frontend\src\app\@shared\announcement\announcement-dialog\announcement-dialog.component.ts */
.announcement-card {
  position: relative;
  text-align: center;
  padding: 20px;
}
.close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  color: #555;
}
.close-btn:hover {
  color: #000;
}
.card-image {
  width: 80%;
  max-height: 200px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 15px;
  margin-top: 25px;
}
.card-title {
  font-weight: 600;
  margin-bottom: 10px;
}
.card-description {
  font-size: 14px;
  margin-bottom: 15px;
}
.card-expiry {
  font-weight: 500;
  color: red;
}
